export default "__VITE_ASSET__cc2e95f0__$_?component__"